<template>
    <div class="sk__listPage sk__listPage_desktop">
        <div class="sk__listPage-count elem"></div>
        <template v-for="item in 8">
            <div class="sk__listPage-card">
                <div class="sk__listPage-card-img elem"></div>
                <div class="sk__listPage-card-content">
                    <div class="sk__listPage-card-content-element w100 mb10 elem"></div>
                    <div class="sk__listPage-card-content-element w70 elem"></div>
                    <div class="sk__listPage-card-content-wrapper">
                        <div class="sk__listPage-card-content-wrapper-elem-1 elem"></div>
                        <div class="sk__listPage-card-content-wrapper-elem-2 elem"></div>
                    </div>
                </div>
                <div class="sk__listPage-card-control">
                    <div class="sk__listPage-card-control-button elem"></div>
                    <div class="sk__listPage-card-control-link elem"></div>
                </div>
            </div>
        </template>
    </div>
    <div class="sk__listPage sk__listPage_mobile">
        <div class="sk__listPage-length elem"></div>
        <template v-for="item in 4">
            <div class="sk__listPage-wrapperCard">
                <div class="sk__listPage-cardMobile">
                    <div class="sk__listPage-cardMobile-header">
                        <div class="sk__listPage-cardMobile-header-left elem"></div>
                        <div class="sk__listPage-cardMobile-header-right elem"></div>
                    </div>
                    <div class="sk__listPage-cardMobile-body">
                        <div class="sk__listPage-cardMobile-body-item elem w100"></div>
                        <div class="sk__listPage-cardMobile-body-item elem w70"></div>
                        <div class="sk__listPage-cardMobile-body-item elem w40"></div>
                    </div>
                    <div class="sk__listPage-cardMobile-footer">
                        <div class="sk__listPage-cardMobile-footer-wrapper">
                            <div class="sk__listPage-cardMobile-footer-elem elem"></div>
                            <div class="sk__listPage-cardMobile-footer-elem elem"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
@import "theme/moydom/less/variables.less";

.sk__listPage {
    &-count {
        height: 20px;
        border-radius: 20px;
        width: 10%;
        margin-top: 40px;
        margin-bottom: 30px;
    }

    &-card {
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 8px;
        background-color: #fafafa;
        margin-bottom: 15px;

        &-img {
            width: 70px;
            height: 70px;
            border-radius: 4px;
            background-color: #cccccc;
            flex-shrink: 0;
            margin: 20px;
        }

        &-content {
            width: 100%;
            margin-right: 20px;

            @media (max-width: @screen-sm) {
                display: none;
            }

            @media (max-width: @screen-xs) {
                display: block;
            }

            &-element {
                border-radius: 48px;
                height: 20px;
            }

            &-wrapper {
                display: flex;
                gap: 6px;
                margin-top: 6px;

                &-elem-1 {
                    width: 16px;
                    height: 16px;
                    border-radius: 2px;
                }

                &-elem-2 {
                    width: 52px;
                    height: 16px;
                    border-radius: 48px;
                }
            }
        }

        &-control {
            display: flex;
            gap: 20px;
            border-left: 1px solid #D9D9D9;
            padding: 31px 20px;

            @media (max-width: @screen-sm) {
                width: 100%;
                justify-content: end;
            }

            &-button {
                width: 233px;
                height: 48px;
                border-radius: 4px;
            }

            &-link {
                width: 48px;
                height: 48px;
                border-radius: 4px;
            }
        }
    }

    &-length {
        width: 40px;
        height: 16px;
        border-radius: 6px;
        margin-top: 30px;
    }

    &-wrapperCard {
        display: flex;
        flex-wrap: wrap;
    }

    &-cardMobile {
        background-color: #FAFAFA;
        border-radius: 6px;
        margin-bottom: 15px;
        margin-top: 15px;
        width: 100%;

        &-header {
            display: flex;
            gap: 6px;
            padding: 15px 15px 0 15px;

            &-left {
                width: 16px;
                height: 16px;
                border-radius: 2px;
            }

            &-right {
                border-radius: 48px;
                width: 52px;
                height: 16px;
            }
        }

        &-body {
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            gap: 9px;
            padding: 0 15px 0 15px;

            &-item {
                border-radius: 48px;
                height: 16px;
            }
        }

        &-footer {
            background-color: #EAEDF0;
            margin-top: 22px;
            border-radius: 0 0 6px 6px;

            &-wrapper {
                display: flex;
                gap: 40px;
                padding: 12px 0 12px 15px;
            }

            &-elem {
                width: 70px;
                height: 16px;
                border-radius: 48px;
            }
        }
    }


    &_desktop {
        @media (max-width: @screen-xs) {
            display: none;
        }
    }

    &_mobile {
        display: none;
        @media (max-width: @screen-xs) {
            display: block;
            padding: 20px 0;
        }
    }
}

.w100 {
    width: 100%;
}

.w70 {
    width: 70%;
}

.w40 {
    width: 40%;
}

.elem {
    background: #EAEDF0;
    position: relative;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(90deg,
        transparent 0%,
        #c3c3c361 30%,
        transparent 100%);
        animation: load 2s infinite;
        content: '';
    }
}

@keyframes load {
    100% {
        transform: translateX(100%);
    }
}
</style>
